<div class="cta-section">
  <div class="cta-banner">
    <div class="cta-banner-glow" aria-hidden="true"></div>

    <h2 class="cta-heading">
      Run your <span class="cta-heading--highlight">store, simply</span>
    </h2>
    <p class="cta-subtext">Sales, stock, and staff — one system, wherever you are.</p>

    <a routerLink="/product" class="cta-btn">Get started — it's free</a>
  </div>

  <div class="cta-quote-card">
    <span class="cta-quote-mark">&#8220;</span>
    <p class="cta-quote-text">Everything is faster and more organized now.</p>
    <div class="cta-author">
      <div class="cta-author-avatar">AR</div>
      <div class="cta-author-info">
        <span class="cta-author-name">Ali Raza</span>
        <span class="cta-author-role">Owner, Retail Store</span>
      </div>
    </div>
  </div>
</div>
